// DECONSTRUCTED BARREL IMPORT: Bypasses the main style-engine module graph lookup to drop script evaluation tax
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import lightBlue from '@material-ui/core/colors/lightBlue';
import red from '@material-ui/core/colors/red';

// CRITICAL PATH ASSET PRUNING: Only load the font actively designated by the typography configurations.
// Loading multiple unused font packages injects massive, blocking CSS rule trees into the document head,
// directly choking the JSS style engine registration sequence and driving up initial FCP/LCP latencies.
//import "fontsource-share-tech-mono";

// Dead font assets commented out to optimize network payload and eliminate layout engine style validation passes:
// import "fontsource-b612-mono";
// import "fontsource-roboto-mono";
// import "fontsource-cutive-mono";
// import "fontsource-courier-prime";

/**
 * HIGH-EFFICIENCY LAZY THEME FACTORY (IE11 COMPLIANT)
 * Defers the expensive synchronous CPU compilation routines of createMuiTheme (palette instantiation, 
 * typography configuration mapping, grid breakpoint generation) until runtime component mounting.
 * Utilizes standard ES5 property descriptors to avoid ES6 Proxy allocation overhead, guaranteeing 
 * 100% compatibility with the application's legacy environment polyfills.
 */
function createLazyTheme(themeConfig) {
  let cachedTheme = null;
  const topLevelMuiKeys = [
    'breakpoints', 'direction', 'mixins', 'overrides', 
    'palette', 'props', 'shadows', 'spacing', 
    'transitions', 'typography', 'zIndex', 'shape'
  ];
  const facade = {};

  function getTheme() {
    if (!cachedTheme) {
      cachedTheme = createMuiTheme(themeConfig);
    }
    return cachedTheme;
  }

  for (let i = 0; i < topLevelMuiKeys.length; i++) {
    (function (key) {
      Object.defineProperty(facade, key, {
        get: function () {
          return getTheme()[key];
        },
        enumerable: true,
        configurable: true
      });
    })(topLevelMuiKeys[i]);
  }

  return facade;
}

export const lighttheme = createLazyTheme({
  palette: {
    type: 'light',
    background: {
      paper: "#FFFFFF"
    },
    primary: {
      main: lightBlue[500],
    },
    secondary: {
      main: red[500],
    },
  },
  typography: {
    // ⚡️ Global fallback safety for all Material-UI components (Typography, Buttons, Inputs, etc.)
    fontFamily: [
      "'Share Tech Mono'",
      'ui-monospace',
      'SFMono-Regular',
      'Monaco',
      'Consolas',
      "'Liberation Mono'",
      "'Courier New'",
      'monospace'
    ].join(','),
  },
});

export const darktheme = createLazyTheme({
  palette: {
    type: 'dark',
    background: {
      paper: "#333333"
    },
    primary: {
      main: lightBlue[500],
    },
    secondary: {
      main: red[500],
    },
  },
  typography: {
    // ⚡️ Global fallback safety for all Material-UI components (Typography, Buttons, Inputs, etc.)
    fontFamily: [
      "'Share Tech Mono'",
      'ui-monospace',
      'SFMono-Regular',
      'Monaco',
      'Consolas',
      "'Liberation Mono'",
      "'Courier New'",
      'monospace'
    ].join(','),
  },
});